import React, { useEffect } from 'react';
import { Grid, Text, RangeSlider, Stack } from '@mantine/core';
import { t } from 'i18next';
import { saveTimeInterval, getTimeInterval } from '../utils/localStorage';

interface TimeIntervalSelectorProps {
  startTime: string;
  endTime: string;
  onStartTimeChange: (value: string) => void;
  onEndTimeChange: (value: string) => void;
}

const formatHour = (hour: number) => {
  return `${hour.toString().padStart(2, '0')}:00`;
};

const timeToValue = (time: string) => {
  const [hours] = time.split(':').map(Number);
  return hours;
};

const marks = Array.from({ length: 25 }, (_, i) => ({
  value: i,
  label: ''
}));

export const TimeIntervalSelector: React.FC<TimeIntervalSelectorProps> = ({
  startTime,
  endTime,
  onStartTimeChange,
  onEndTimeChange,
}) => {
  useEffect(() => {
    const savedInterval = getTimeInterval();
    onStartTimeChange(savedInterval.startTime);
    onEndTimeChange(savedInterval.endTime);
  }, [onStartTimeChange, onEndTimeChange]);

  const handleRangeChange = ([start, end]: [number, number]) => {
    const newStartTime = formatHour(start);
    const newEndTime = formatHour(end);
    onStartTimeChange(newStartTime);
    onEndTimeChange(newEndTime);
    saveTimeInterval(newStartTime, newEndTime);
  };

  return (
    <Grid align="center" mt="xs">
      <Grid.Col span={4}>
        <Text fw={600}>{t('graph.timeInterval')}</Text>
      </Grid.Col>
      <Grid.Col span={4}>
        <Stack gap="xs">
          <div style={{ padding: '0 10px' }}>
            <Text size="sm" ta="center">
              {startTime} - {endTime}
            </Text>
          </div>
          <RangeSlider
            min={0}
            max={24}
            step={1}
            marks={marks}
            value={[timeToValue(startTime), timeToValue(endTime)]}
            onChange={handleRangeChange}
            size="sm"
            label={formatHour}
            minRange={1}
            styles={{
              markLabel: {
                fontSize: '12px',
                transform: 'translateY(15px)'
              },
              mark: {
                height: '8px',
                width: '2px',
                transform: 'translateX(-1px)'
              },
              thumb: {
                borderWidth: 2,
                height: 16,
                width: 16,
                backgroundColor: 'white',
                transition: 'transform 100ms ease',
                ':hover': {
                  transform: 'scale(1.1)'
                }
              }
            }}
          />
        </Stack>
      </Grid.Col>
    </Grid>
  );
};